import { render, staticRenderFns } from "./AboutUs1Template.vue?vue&type=template&id=6928a5da"
import script from "./AboutUs1Template.vue?vue&type=script&lang=js"
export * from "./AboutUs1Template.vue?vue&type=script&lang=js"
import style0 from "./AboutUs1Template.vue?vue&type=style&index=0&id=6928a5da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports